
import wx from '@/common/wechat/sdk/jweixin-1.6.0'
import { isEnableOpenWeapp } from './../utils'
import Alert from 'vux/src/components/alert/index.vue'

import XDialog from 'vux/src/components/x-dialog/index.vue';
export default {
name: 'AlertToShop',
components: {
Alert,
XDialog
},
data() {
return {
visible: false,
showContactDialog: false,
appletData: {
id: 'gh_9c2320a2d832',
path: 'pages/sub/store/store',
name: '华安门店查询',
},
}
},
created() {
wx.ready((res) => {
console.log('res', res)
})
wx.error((err) => {
console.log('error', err)
})
},
computed: {
isWx() {
return isEnableOpenWeapp()
}
},
methods: {

toPage() {
location.href = '/pages/sub/store/store'
},
show() {
this.visible = true
},
hide() {
this.visible = false
},
},
}
